import { Stack, Typography } from '@mui/material'
import { type SystemStyleObject } from '@mui/system'
import React from 'react'

import Text from 'components/common/Text'
import theme from 'theme'

export function PanelSection(props) {
  return <section {...props} />
}

export const PanelHeader: React.FC<{ sx?: SystemStyleObject }> = ({
  sx,
  ...props
}) => (
  <Stack
    alignItems="center"
    component="section"
    direction="row"
    spacing={1}
    sx={{ borderBottom: theme.border.base, pb: 1, ...sx }}
    {...props}
  />
)

export const PanelTitle = (props) => (
  <Typography variant="subtitle1" {...props} sx={{ fontWeight: 500 }} />
)

export const PanelDetails = (props) => (
  <section css={{ marginTop: theme.space[4], width: '100%' }} {...props} />
)

export const PanelDetailsGrid = (props) => (
  <PanelDetails
    css={{
      display: 'grid',
      gridTemplateColumns: 'fit-content(160px) 1fr',
      gap: theme.space[3],
      gridColumnGap: theme.space[4]
    }}
    {...props}
  />
)

export const PanelRow = (props) => (
  <div
    css={{
      marginBottom: theme.space[3],
      display: 'grid',
      gridTemplateColumns: '160px 1fr',
      gap: theme.space[3],
      fontWeight: theme.fontWeights[1],
      wordBreak: 'break-word'
    }}
    {...props}
  />
)

export function Label(props) {
  return <Text as="span" color="normal" {...props} />
}

export function Value(props) {
  return (
    <Text
      as="span"
      color="dark"
      css={{ wordBreak: 'break-word' }}
      weight="normal"
      {...props}
    />
  )
}
